import "core-js/modules/es6.array.from";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.array.some";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.index-of";
import _regeneratorRuntime from "/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/runner/work/landing-page/landing-page/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.map";
import { b as getIonMode } from './ionic-global-a175fa73.js';
import { c as createAnimation } from './animation-f72ade61.js';
import { MENU_BACK_BUTTON_PRIORITY } from './hardware-back-button-784b7e3c.js';
/**
 * baseAnimation
 * Base class which is extended by the various types. Each
 * type will provide their own animations for open and close
 * and registers itself with Menu.
 */

var baseAnimation = function baseAnimation(isIos) {
  // https://material.io/guidelines/motion/movement.html#movement-movement-in-out-of-screen-bounds
  // https://material.io/guidelines/motion/duration-easing.html#duration-easing-natural-easing-curves

  /**
   * "Apply the sharp curve to items temporarily leaving the screen that may return
   * from the same exit point. When they return, use the deceleration curve. On mobile,
   * this transition typically occurs over 300ms" -- MD Motion Guide
   */
  return createAnimation().duration(isIos ? 400 : 300);
};
/**
 * Menu Overlay Type
 * The menu slides over the content. The content
 * itself, which is under the menu, does not move.
 */


var menuOverlayAnimation = function menuOverlayAnimation(menu) {
  var closedX;
  var openedX;
  var width = menu.width + 8;
  var menuAnimation = createAnimation();
  var backdropAnimation = createAnimation();

  if (menu.isEndSide) {
    // right side
    closedX = width + 'px';
    openedX = '0px';
  } else {
    // left side
    closedX = -width + 'px';
    openedX = '0px';
  }

  menuAnimation.addElement(menu.menuInnerEl).fromTo('transform', "translateX(".concat(closedX, ")"), "translateX(".concat(openedX, ")"));
  var mode = getIonMode(menu);
  var isIos = mode === 'ios';
  var opacity = isIos ? 0.2 : 0.25;
  backdropAnimation.addElement(menu.backdropEl).fromTo('opacity', 0.01, opacity);
  return baseAnimation(isIos).addAnimation([menuAnimation, backdropAnimation]);
};
/**
 * Menu Push Type
 * The content slides over to reveal the menu underneath.
 * The menu itself also slides over to reveal its bad self.
 */


var menuPushAnimation = function menuPushAnimation(menu) {
  var contentOpenedX;
  var menuClosedX;
  var mode = getIonMode(menu);
  var width = menu.width;

  if (menu.isEndSide) {
    contentOpenedX = -width + 'px';
    menuClosedX = width + 'px';
  } else {
    contentOpenedX = width + 'px';
    menuClosedX = -width + 'px';
  }

  var menuAnimation = createAnimation().addElement(menu.menuInnerEl).fromTo('transform', "translateX(".concat(menuClosedX, ")"), 'translateX(0px)');
  var contentAnimation = createAnimation().addElement(menu.contentEl).fromTo('transform', 'translateX(0px)', "translateX(".concat(contentOpenedX, ")"));
  var backdropAnimation = createAnimation().addElement(menu.backdropEl).fromTo('opacity', 0.01, 0.32);
  return baseAnimation(mode === 'ios').addAnimation([menuAnimation, contentAnimation, backdropAnimation]);
};
/**
 * Menu Reveal Type
 * The content slides over to reveal the menu underneath.
 * The menu itself, which is under the content, does not move.
 */


var menuRevealAnimation = function menuRevealAnimation(menu) {
  var mode = getIonMode(menu);
  var openedX = menu.width * (menu.isEndSide ? -1 : 1) + 'px';
  var contentOpen = createAnimation().addElement(menu.contentEl) // REVIEW
  .fromTo('transform', 'translateX(0px)', "translateX(".concat(openedX, ")"));
  return baseAnimation(mode === 'ios').addAnimation(contentOpen);
};

var createMenuController = function createMenuController() {
  var menuAnimations = new Map();
  var menus = [];

  var open = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(menu) {
      var menuEl;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return get(menu);

            case 2:
              menuEl = _context.sent;

              if (!menuEl) {
                _context.next = 5;
                break;
              }

              return _context.abrupt("return", menuEl.open());

            case 5:
              return _context.abrupt("return", false);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function open(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var close = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(menu) {
      var menuEl;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return menu !== undefined ? get(menu) : getOpen();

            case 2:
              menuEl = _context2.sent;

              if (!(menuEl !== undefined)) {
                _context2.next = 5;
                break;
              }

              return _context2.abrupt("return", menuEl.close());

            case 5:
              return _context2.abrupt("return", false);

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function close(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var toggle = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(menu) {
      var menuEl;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return get(menu);

            case 2:
              menuEl = _context3.sent;

              if (!menuEl) {
                _context3.next = 5;
                break;
              }

              return _context3.abrupt("return", menuEl.toggle());

            case 5:
              return _context3.abrupt("return", false);

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function toggle(_x3) {
      return _ref3.apply(this, arguments);
    };
  }();

  var enable = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(shouldEnable, menu) {
      var menuEl;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return get(menu);

            case 2:
              menuEl = _context4.sent;

              if (menuEl) {
                menuEl.disabled = !shouldEnable;
              }

              return _context4.abrupt("return", menuEl);

            case 5:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function enable(_x4, _x5) {
      return _ref4.apply(this, arguments);
    };
  }();

  var swipeGesture = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(shouldEnable, menu) {
      var menuEl;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return get(menu);

            case 2:
              menuEl = _context5.sent;

              if (menuEl) {
                menuEl.swipeGesture = shouldEnable;
              }

              return _context5.abrupt("return", menuEl);

            case 5:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function swipeGesture(_x6, _x7) {
      return _ref5.apply(this, arguments);
    };
  }();

  var isOpen = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(menu) {
      var menuEl, _menuEl;

      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (!(menu != null)) {
                _context6.next = 7;
                break;
              }

              _context6.next = 3;
              return get(menu);

            case 3:
              menuEl = _context6.sent;
              return _context6.abrupt("return", menuEl !== undefined && menuEl.isOpen());

            case 7:
              _context6.next = 9;
              return getOpen();

            case 9:
              _menuEl = _context6.sent;
              return _context6.abrupt("return", _menuEl !== undefined);

            case 11:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function isOpen(_x8) {
      return _ref6.apply(this, arguments);
    };
  }();

  var isEnabled = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(menu) {
      var menuEl;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return get(menu);

            case 2:
              menuEl = _context7.sent;

              if (!menuEl) {
                _context7.next = 5;
                break;
              }

              return _context7.abrupt("return", !menuEl.disabled);

            case 5:
              return _context7.abrupt("return", false);

            case 6:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function isEnabled(_x9) {
      return _ref7.apply(this, arguments);
    };
  }();

  var get = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(menu) {
      var menuRef, menuEl;
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return waitUntilReady();

            case 2:
              if (!(menu === 'start' || menu === 'end')) {
                _context8.next = 9;
                break;
              }

              // there could be more than one menu on the same side
              // so first try to get the enabled one
              menuRef = find(function (m) {
                return m.side === menu && !m.disabled;
              });

              if (!menuRef) {
                _context8.next = 6;
                break;
              }

              return _context8.abrupt("return", menuRef);

            case 6:
              return _context8.abrupt("return", find(function (m) {
                return m.side === menu;
              }));

            case 9:
              if (!(menu != null)) {
                _context8.next = 11;
                break;
              }

              return _context8.abrupt("return", find(function (m) {
                return m.menuId === menu;
              }));

            case 11:
              // return the first enabled menu
              menuEl = find(function (m) {
                return !m.disabled;
              });

              if (!menuEl) {
                _context8.next = 14;
                break;
              }

              return _context8.abrupt("return", menuEl);

            case 14:
              return _context8.abrupt("return", menus.length > 0 ? menus[0].el : undefined);

            case 15:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function get(_x10) {
      return _ref8.apply(this, arguments);
    };
  }();
  /**
   * Get the instance of the opened menu. Returns `null` if a menu is not found.
   */


  var getOpen = /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return waitUntilReady();

            case 2:
              return _context9.abrupt("return", _getOpenSync());

            case 3:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    return function getOpen() {
      return _ref9.apply(this, arguments);
    };
  }();
  /**
   * Get all menu instances.
   */


  var getMenus = /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return waitUntilReady();

            case 2:
              return _context10.abrupt("return", getMenusSync());

            case 3:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));

    return function getMenus() {
      return _ref10.apply(this, arguments);
    };
  }();
  /**
   * Get whether or not a menu is animating. Returns `true` if any
   * menu is currently animating.
   */


  var isAnimating = /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return waitUntilReady();

            case 2:
              return _context11.abrupt("return", isAnimatingSync());

            case 3:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }));

    return function isAnimating() {
      return _ref11.apply(this, arguments);
    };
  }();

  var registerAnimation = function registerAnimation(name, animation) {
    menuAnimations.set(name, animation);
  };

  var _register = function _register(menu) {
    if (menus.indexOf(menu) < 0) {
      if (!menu.disabled) {
        _setActiveMenu(menu);
      }

      menus.push(menu);
    }
  };

  var _unregister = function _unregister(menu) {
    var index = menus.indexOf(menu);

    if (index > -1) {
      menus.splice(index, 1);
    }
  };

  var _setActiveMenu = function _setActiveMenu(menu) {
    // if this menu should be enabled
    // then find all the other menus on this same side
    // and automatically disable other same side menus
    var side = menu.side;
    menus.filter(function (m) {
      return m.side === side && m !== menu;
    }).forEach(function (m) {
      return m.disabled = true;
    });
  };

  var _setOpen = /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(menu, shouldOpen, animated) {
      var openedMenu;
      return _regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              if (!isAnimatingSync()) {
                _context12.next = 2;
                break;
              }

              return _context12.abrupt("return", false);

            case 2:
              if (!shouldOpen) {
                _context12.next = 9;
                break;
              }

              _context12.next = 5;
              return getOpen();

            case 5:
              openedMenu = _context12.sent;

              if (!(openedMenu && menu.el !== openedMenu)) {
                _context12.next = 9;
                break;
              }

              _context12.next = 9;
              return openedMenu.setOpen(false, false);

            case 9:
              return _context12.abrupt("return", menu._setOpen(shouldOpen, animated));

            case 10:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12);
    }));

    return function _setOpen(_x11, _x12, _x13) {
      return _ref12.apply(this, arguments);
    };
  }();

  var _createAnimation = function _createAnimation(type, menuCmp) {
    var animationBuilder = menuAnimations.get(type);

    if (!animationBuilder) {
      throw new Error('animation not registered');
    }

    var animation = animationBuilder(menuCmp);
    return animation;
  };

  var _getOpenSync = function _getOpenSync() {
    return find(function (m) {
      return m._isOpen;
    });
  };

  var getMenusSync = function getMenusSync() {
    return menus.map(function (menu) {
      return menu.el;
    });
  };

  var isAnimatingSync = function isAnimatingSync() {
    return menus.some(function (menu) {
      return menu.isAnimating;
    });
  };

  var find = function find(predicate) {
    var instance = menus.find(predicate);

    if (instance !== undefined) {
      return instance.el;
    }

    return undefined;
  };

  var waitUntilReady = function waitUntilReady() {
    return Promise.all(Array.from(document.querySelectorAll('ion-menu')).map(function (menu) {
      return menu.componentOnReady();
    }));
  };

  registerAnimation('reveal', menuRevealAnimation);
  registerAnimation('push', menuPushAnimation);
  registerAnimation('overlay', menuOverlayAnimation);
  /* tslint:disable-next-line */

  if (typeof document !== 'undefined') {
    document.addEventListener('ionBackButton', function (ev) {
      var openMenu = _getOpenSync();

      if (openMenu) {
        ev.detail.register(MENU_BACK_BUTTON_PRIORITY, function () {
          return openMenu.close();
        });
      }
    });
  }

  return {
    registerAnimation: registerAnimation,
    get: get,
    getMenus: getMenus,
    getOpen: getOpen,
    isEnabled: isEnabled,
    swipeGesture: swipeGesture,
    isAnimating: isAnimating,
    isOpen: isOpen,
    enable: enable,
    toggle: toggle,
    close: close,
    open: open,
    _getOpenSync: _getOpenSync,
    _createAnimation: _createAnimation,
    _register: _register,
    _unregister: _unregister,
    _setOpen: _setOpen,
    _setActiveMenu: _setActiveMenu
  };
};

var menuController = /*@__PURE__*/createMenuController();
export { menuController as m };